const VIEW_CRQ = {
  path: '/crq/:network/:crqId/:context?',
  getPath: ({ network, crqId }) => `/crq/${network}/${crqId}`,
};

const MY_CRQ = {
  path: '/mycrq/:network/:name/:status(closed|cancelled)?',
  getPath: ({ network, crqId }) => `/crq/${network}`,
};

const HELP_SECTION = {
  path: '/help',
  getPath: () => '/help',
};

const EDIT_CRQ = {
  path: '/crq/edit/:network/:crqId/:sectionId',
  getPath: ({ network, crqId, sectionId }) => `/crq/${network}/${crqId}/${sectionId}`,
};

const CRQ_TRANSITION_CONFIRMATION = {
  path: '/crq/confirmation/:network/:crqId/:transitionId?',
  getPath: ({ network, crqId, transitionId }) => {
    const transitionIdParam = transitionId ? `/${transitionId}` : '';
    return `/crq/confirmation/${network}/${crqId}${transitionIdParam}`;
  },
};

const CRQS_SCREEN = {
  // restrict the status parameter to be one of closed, cancelled or blank
  path: '/crqs/:network?/:coordinatorGroup?/:status(closed|cancelled)?',
  getPath: (status) => (status ? `/crqs/all/all/${status}` : '/crqs'),
};

const SEARCH_CRQS = {
  path: '/crqs/search/:query',
  getPath: (query) => `/crqs/search/${query}`,
};

export {
  VIEW_CRQ,
  EDIT_CRQ,
  CRQ_TRANSITION_CONFIRMATION,
  CRQS_SCREEN,
  SEARCH_CRQS,
  MY_CRQ,
  HELP_SECTION,
};
